<div [class]="cardClasses">
    <ng-content></ng-content>
</div>